import { Box, IconButton, Tooltip } from '@mui/material'
import {
  CameraAltOutlined as CameraIcon,
  FileUploadOutlined as UploadIcon,
} from '@mui/icons-material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { ICON_SIZE } from '@/shared/styles/typography'

interface Props {
  onCapture: () => void
  onPick: () => void
}

// 釦の名前 (tooltip と aria-label。見える文字は持たない)
export const CAPTURE_LABEL = '撮る'
export const PICK_LABEL = '画像・PDF を選ぶ'

// 資料を足す口。文字の無い icon の釦 2 つ ([📷 撮る][⬆ 選ぶ]) を隣に並べ、どの端末でも同じ場所・同じ並び・同じ見た目
// (塗りは付けない — 足すのは主動線でなく、塗りが端末で入れ替わる規則は使う人に見えない)。名前は tooltip と aria-label
// (design-book 00-principles/03-subtraction.md §2・02-components/attachments-panel.md「足す口」)。
// カメラの無い端末 (AnyCOMPASS の iframe) でも「撮る」は出す — 出し分けると口の場所が端末で変わる。
// タッチでは描画を 28px のまま ::after で 44px の当たりを稼ぐ (design-book 02-components/button.md「タッチ環境」)。
const buttonSx = {
  width: 28,
  height: 28,
  color: colorTokens.fg.muted,
  '&:hover': {
    bgcolor: colorTokens.bg.muted,
    color: colorTokens.fg.default,
  },
  '@media (pointer: coarse)': {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 44,
      height: 44,
    },
  },
} as const

export const AttachmentAddButtons = ({ onCapture, onPick }: Props) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <Tooltip title={CAPTURE_LABEL} placement="bottom">
      <IconButton
        size="small"
        aria-label={CAPTURE_LABEL}
        onClick={onCapture}
        sx={buttonSx}
      >
        <CameraIcon sx={{ fontSize: ICON_SIZE.md }} />
      </IconButton>
    </Tooltip>
    <Tooltip title={PICK_LABEL} placement="bottom">
      <IconButton
        size="small"
        aria-label={PICK_LABEL}
        onClick={onPick}
        sx={buttonSx}
      >
        <UploadIcon sx={{ fontSize: ICON_SIZE.md }} />
      </IconButton>
    </Tooltip>
  </Box>
)
